import { _get } from "../../../http";

// cuentas comerciales
export const getCuentasComerciales = () => _get("/cuentaBancaria?esPrincipal=true");

export const get = (cuentaComercialId) => _get(`/cuentaBancaria/${cuentaComercialId}`);
